<template>
  <div class="Div">
    <div class="backimg">

      <img
        class="img"
        :src="titleList.banner.banner_img"
        alt=""
      >
      <p class="Title">
        {{ titleList.banner.banner_name_cn}}
      </p>
    </div>
    <div class="nav">
      <ul>
        <li
          :class="navId==item.id?'li active':'li'"
          v-for="(item,i) of warmNav"
          :key="i"
          @click="navClick(item)"
        >
          {{titleList.navbar[i]}}
        </li>
      </ul>
    </div>
    <div class="divFin">
    <labars-bread></labars-bread>
    </div>
    <section class="sectionContent">
      <!-- 家长志愿者 -->
      <div
        v-if="navId==0"
        class="volPar"
      >
        <div
          class="volunteer"
          v-for="(item,i) of list1"
          :key="i"
        >
          <img
            class="img"
            :src="item.volunteer_img"
            alt=""
          >
          <p class="name">{{item.volunteer_name_cn}}</p>
          <p class="office">{{item.volunteer_explain_cn}}</p>
        </div>
      </div>
      <!-- 家长课堂 -->
      <div v-else-if="navId==1">
        <div
          class="fineTitle"
          v-for="(item,i) of list2"
          :key="i"
          @click="details(item)"
        >
          <p
            class="t_p ellipsis"
            :title="item.article_title_cn"
          >
            {{item.article_title_cn}}
          </p>
          <p class="time">
            {{item.send_time}}
          </p>
        </div>

      </div>
      <el-pagination
        :background="true"
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :total="total"
        class="page"
        :current-page="page"
        @current-change="changePage"
      >
      </el-pagination>
    </section>

  </div>
</template>
<script>
import {
  VolunteerList,
  coeducationConfig,
  parentsClassroom
} from "../../api/Overview";
import LabarsBread from "../../layout/LabarsBread";
export default {
  name: "CoCultivation",
  data() {
    return {
      warmNav: [
        {
          name: "家长志愿者",
          id: 0
        },
        {
          name: "家长课堂",
          id: 1
        }
      ],
      navId: 0,
      page: 1,
      uid: "",
      total: 1000,
      list1: {},
      list2: {},
      titleList: { banner: {}, navbar: {} }
    };
  },
  components: {
    LabarsBread
  },
  methods: {
    navClick(item) {
      if (item.id != this.navId) {
        this.navId = item.id;
        this.page = 1;
        if (this.navId == 0) {
          this.VolunteerLists();
        } else {
          this.ParentClass();
        }
      }
      //   console.log(this.page);
    },
    changePage(val) {
      this.page = val;
      if (this.navId == 0) {
        this.VolunteerLists();
      } else {
        this.ParentClass();
      }
    },
    // 获取家长志愿者
    VolunteerLists() {
      VolunteerList({
        park: this.uid,
        per_page: 10,
        page: this.page
      }).then(res => {
        // console.log(res.data)
        this.list1 = res.data.list;
        this.total = res.data.count;
      });
    },
    // 获取家长课堂
    ParentClass() {
      parentsClassroom({
        park: this.uid,
        per_page: 10,
        page: this.page
      }).then(res => {
        // console.log(res.data)
        this.list2 = res.data.list;
        this.total = res.data.count;
      });
    },
    // 跳转详情
    details(item) {
      var laber = JSON.parse(this.$route.query.laber);
      var laPath = JSON.parse(this.$route.query.laPath);
      laPath.push(this.$route.path);
      laber.push(18);
      var routeData=this.$router.resolve({
        path: "/NewsDetails",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          id: item.article_id
        }
      });
      window.open(routeData.href, "_blank");
    }
  },
  created() {
    this.uid = this.$route.query.uid;
    this.VolunteerLists();
    // console.log(this.$route.query.laber,this.$route.query.laPath)
    coeducationConfig({
      park: this.uid
    }).then(res => {
      // console.log(res.data)
      this.titleList = res.data;
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  // min-height: 100%;
  padding: 0.1px 0;
  background: #f5f5f5;
  .backimg {
    position: relative;
    width: 100%;
    height: px2Rem(400px);
    &::after {
      display: block;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      //   z-index: 1;
    }
    .img {
      //   position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.Title {
  position: absolute;
  width: 100%;
  top: px2Rem(160px);
  font-size: px2Rem(80px);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  z-index: 1;
  text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
}
.nav {
  width: 100%;
  height: px2Rem(100px);
  background: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 9px 0px rgba(0, 0, 0, 0.3);
  line-height: px2Rem(100px);
  ul {
    width: px2Rem(1300px);
    height: 100%;
    margin: auto;
    .li {
      display: inline-block;
      position: relative;
      height: 100%;
      margin-right: px2Rem(80px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(120, 120, 120, 1);
      cursor: pointer;
      vertical-align: top;
      //   transition: 0.3s;
      &:last-of-type {
        margin-right: 0;
      }
      &::after {
        display: block;
        position: absolute;
        width: px2Rem(0px);
        height: 2px;
        content: "";
        transition: 0.3s;
        left: 50%;
        // bottom: 0;
        transform: translate(-50%, 0);
      }
      &:hover {
        &::after {
          display: block;
          content: "";
          position: absolute;
          width: px2Rem(110px);
          height: 2px;
          bottom: 0;
          background: rgba(28, 50, 120, 1);
          border-radius: 1px;
          transition: 0.3s;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }
    }
    .active {
      font-size: px2Rem(34px);
      color: #333;
      &::after {
        display: block;
        content: "";
        position: absolute;
        width: px2Rem(110px);
        height: 2px;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        background: rgba(28, 50, 120, 1);
        border-radius: 1px;
      }
    }
  }
}
.sectionContent {
  width: px2Rem(1300px);
  margin: px2Rem(20px) auto px2Rem(64px);
  padding-bottom: px2Rem(75px);
  background: rgba(255, 255, 255, 1);
  .fineTitle {
    padding: px2Rem(30px) px2Rem(20px);
    border-bottom: 1px dashed rgba(221, 221, 221, 1);
    cursor: pointer;
    transition: .5s;
    .t_p {
      margin-bottom: px2Rem(20px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    &:hover {
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
      .t_p {
        color: #1c3278;
      }
    }
    .time {
      font-size: px2Rem(18px);
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
  }
  .volPar {
    padding: px2Rem(30px);
  }
  .volunteer {
    display: inline-block;
    width: px2Rem(190px);
    margin-right: px2Rem(70px);
    margin-bottom: px2Rem(30px);
    text-align: center;
    vertical-align: top;
    &:nth-of-type(5n) {
      margin-right: px2Rem(0px);
    }
    .img {
      display: block;
      width: 100%;
      height: px2Rem(234px);
      margin-bottom: px2Rem(20px);
    }
    .name {
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .office {
      font-size: px2Rem(24px);
      font-weight: 400;
      color: rgba(96, 96, 96, 1);
    }
  }
}
.page {
  margin-top: px2Rem(40px);
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/index/CoCultivation.vue